import { ChunkAST } from './parseMarkdown';

export function buildChunkMeta(
  chunkAsts: ChunkAST[],
  startingIndex = 0,
  titleOverrides: string[] = []
) {
  return chunkAsts.map((chunk, i) => {
    const idx = i + startingIndex;
    const title = titleOverrides[i] ?? `Section ${idx + 1}`;
    return {
      chunk,
      title
    };
  });
}
